var _defs, _text, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPunchappLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221,
    height: 61,
    viewBox: "0 0 221 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.846,
    y2: 1.202,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6418c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a827e4"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Bayar",
    transform: "translate(71 7)",
    fill: "#333",
    fontSize: 25,
    fontFamily: "Cairo-Bold, Cairo",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "HR Portal"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    d: "M14,0H40A14,14,0,0,1,54,14V40A14,14,0,0,1,40,54H14A14,14,0,0,1,0,40V14A14,14,0,0,1,14,0Z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    "data-name": "Logo",
    transform: "translate(-49 -48)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "translate(64 88)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunchappLogo);
export default __webpack_public_path__ + "static/media/punchapp-logo.22fc30bf75bc319da7442344dc7c180d.svg";
export { ForwardRef as ReactComponent };